module.exports = __webpack_public_path__ + "static/media/historic_georgian_1.2e3cc14b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/historic_georgian_1.jpg
// module id = 152
// module chunks = 0